import { styled } from '@clickcease/cc-client-components-lib'

export const TrialPreEndModalStyled = styled('div', {
  width: '626px',
  height: '385px',
  padding: '50px 22px 22px 22px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  variants: {
    noTag: {
      true: {
        width: '455px',
        height: '220px',
      },
    },
  },
})

export const TrialPreEndModalTitle = styled('div', {
  fontSize: '$h1',
  fontWeight: '$sb',
  textAlign: 'center',
})

export const TrialPreEndModalSubTitle = styled('div', {
  fontSize: '$lg',
  fontWeight: '$l',
  textAlign: 'center',
  marginTop: '$4',
  width: '343px',
})

export const TrialPreEndModalYourPerformance = styled('div', {
  fontSize: '$lg',
  fontWeight: '$l',
  textAlign: 'center',
  margin: '$16 0px',
})

export const TrialPreEndModalNoTag = styled('div', {
  fontSize: '$lg',
  fontWeight: '$l',
  textAlign: 'center',
  margin: '$16 0px',
  width: '368px',
})

export const TrialPreEndModalCard = styled('div', {
  height: '124px',
  padding: '$8 $6 $8 $6',
  boxShadow: '0px 0px 30px 0px #6666660D',
  border: '1px solid $veryLightGray',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '12px',

  variants: {
    bundle: {
      true: { width: '178px' },
    },
  },
})
